document.addEventListener('DOMContentLoaded', function () {
  const mz = window.mz;

  if (!mz) {
    return;
  }

  if (mz.context && mz.context.filterShow) {
    // placeholder
  }

  function lazyLoadItem(el, item, callback) {
    const url =
      `/collections/all?section_id=${encodeURIComponent(mz.sectionId)}` +
      `&sort_by=${encodeURIComponent(`mezereon:${item.handle}`)}`;

    console.log('Mezereon Produktkarten Request:', url);

    fetch(url)
      .then((response) => {
        console.log('Mezereon Section Status:', response.status);

        if (!response.ok) {
          throw new Error(`Section Request fehlgeschlagen: ${response.status}`);
        }

        return response.text();
      })
      .then((responseText) => {
        console.log('Mezereon Section HTML:', responseText);

        const html = new DOMParser().parseFromString(
          responseText,
          'text/html',
        );

        const mzCardProduct = html.querySelector('.mz-card-product');

        console.log('Gefundene Produktkarte:', mzCardProduct);

        if (!mzCardProduct) {
          throw new Error(
            `Keine .mz-card-product gefunden. Section ID: ${mz.sectionId}, Handle: ${item.handle}`,
          );
        }

        callback(mzCardProduct.innerHTML);

        setTimeout(() => {
          const newItems = el.querySelectorAll(
            '.anm-reveal-item[data-active="false"]',
          );

          newItems.forEach((newItem) => {
            newItem.dataset.active = 'true';
          });

          document.dispatchEvent(
            new CustomEvent('maximize:animation:reveal'),
          );

          if (window.Alpine) {
            const mzApp = document.getElementById('mz-app');

            if (mzApp) {
              mzApp.querySelectorAll('[x-data]').forEach((element) => {
                if (!element._x_dataStack) {
                  window.Alpine.initTree(element);
                }
              });
            }
          }
        }, 200);
      })
      .catch((error) => {
        console.error('Mezereon Lazy Load Fehler:', error);
      });
  }

  function afterUpdate() {
    setTimeout(() => {
      const items = document.querySelectorAll(
        '.anm-reveal-item[data-active="false"]',
      );

      items.forEach((item) => {
        item.dataset.active = 'true';
      });

      document.dispatchEvent(
        new CustomEvent('maximize:animation:reveal'),
      );

      if (window.Alpine) {
        const mzApp = document.getElementById('mz-app');

        if (mzApp) {
          mzApp.querySelectorAll('[x-data]').forEach((element) => {
            if (!element._x_dataStack) {
              window.Alpine.initTree(element);
            }
          });
        }
      }
    }, 200);
  }

  function reloadSection(event) {
    if (
      !event.detail ||
      event.detail.sectionId !== mz.sectionId
    ) {
      return;
    }

    if (typeof mz.initializeVueApp === 'function') {
      mz.initializeVueApp();
    }
  }

  function closeSearch() {
    const closeBtn = document.querySelector('#SearchClose__desktop');

    if (closeBtn) {
      closeBtn.click();
    }
  }

  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate);
    mz.app.$bus.on('lazy-load-item', lazyLoadItem);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener(
        'shopify:section:load',
        reloadSection,
      );
    }
  } else {
    console.error('Mezereon Event Bus nicht verfügbar:', mz.app);
  }

  if (mz.suggest && mz.suggest.$bus) {
    mz.suggest.$bus.on('run-query', closeSearch);
  }
});